import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { ConversationsService } from "src/app/dashboard/conversations/conversations.service";
import { Conversation } from "src/app/dashboard/conversations/panels/conversation.model";
import { DashboardStore } from "src/app/dashboard/dashboard.store";
import { QuickbooksIntegrationService } from "src/app/dashboard/quickbooks-integration.service";
import { RealTimeService } from "../../common/notifications/real-time.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { DashboardService } from "src/app/dashboard/dashboard.service";
import { HotToastService } from "@ngneat/hot-toast";
import { WorkspacesService } from "../workspaces.service";
import { environment } from "src/environments/environment";
import Pusher from "pusher-js";
import { AutosizeModule } from "ngx-autosize";
import { FormsModule } from "@angular/forms";
import { MessageBubbleComponent } from "../../../conversations/message-bubble/message-bubble.component";
import { TrackedItemBubbleComponent } from "../../../conversations/tracked-item-bubble/tracked-item-bubble.component";
import { NgClass, NgIf, NgFor } from "@angular/common";
import { ConfirmationModalComponent } from '../modals/confirmation-modal.component';

@Component({
    selector: "app-client-tasks",
    templateUrl: "./client-tasks.component.html",
    styleUrls: ["./client-tasks.component.scss"],
    host: {
        "(document:click)": "clickout($event)",
        class: 'client-task-drawer'
    },
    imports: [
        NgClass,
        NgIf,
        TrackedItemBubbleComponent,
        NgFor,
        MessageBubbleComponent,
        FormsModule,
        AutosizeModule,
    ]
})
export class ClientTasksComponent implements OnInit {
  private pusher: Pusher;
  private channel: any;

  autoRemind = false;
  autoRemindDays = "2";
  tracked_item = null;
  user: any;
  accounts = [];
  classes = [];
  _conversation: Conversation;
  isOpen = false;
  isAccountant = false;
  isSendingComment = false;
  @ViewChild("input", { static: true }) input: ElementRef;
  @ViewChild("commentsWrapper") private commentsWrapper: ElementRef;
  bsModalRef: BsModalRef;
  hasSelectableClass = false;

  realtimeUpdateSubscriptions = [];

  @ViewChild("deleteTrackedItemConfirmation", { read: TemplateRef })
  deleteTrackedItemConfirmation: TemplateRef<any>;

  getParents(node, memo) {
    memo = memo || [];
    var parentNode = node.parentNode;

    if (!parentNode) {
      return memo;
    } else {
      return this.getParents(parentNode, memo.concat(parentNode));
    }
  }

  eventPath(evt) {
    var path = (evt.composedPath && evt.composedPath()) || evt.path,
      target = evt.target;

    if (path != null) {
      // Safari doesn't include Window, but it should.
      return path.indexOf(window) < 0 ? path.concat(window) : path;
    }

    if (target === window) {
      return [window];
    }

    return [target].concat(this.getParents(target, window));
  }

  clickout(event) {
    const path = this.eventPath(event);
    if (!this._eref.nativeElement.contains(event.target)) {
      let isTrackedItemBubble = path.some((p) => {
        return (
          p.localName == "tracked-item-bubble" ||
          p.localName == "app-modal-file-upload" ||
          p.localName == "ch-file-preview" ||
          p.localName == "modal-container" ||
          p.localName == "bs-dropdown-container"
        );
      });

      if (!isTrackedItemBubble) {
        setTimeout(() => {
          if (this.isOpen) {
            this.tracked_item = null;
            this.isOpen = false;
          }
        });
      }
    }
  }

  @Input()
  set conversation(value: Conversation) {
    if (value != null) {
      this._conversation = value;
    }
  }

  company: any;

  constructor(
    public dashboardStore: DashboardStore,
    private quickbooksIntegrationService: QuickbooksIntegrationService,
    private conversationsService: ConversationsService,
    private localStorage: LocalStorageService,
    private _eref: ElementRef,
    private realTimeService: RealTimeService,
    private cdr: ChangeDetectorRef,
    public modalService: BsModalService,
    private dashboardService: DashboardService,
    private toastr: HotToastService,
    private workspacesService: WorkspacesService,
  ) {}

  send_comment(message, tracked_item_id, input): void {
    input.value = "";
    if (message.trim() != "" && !this.isSendingComment) {
      this.isSendingComment = true;
      const hash = Math.random().toString(36).substring(7);
      this.tracked_item.comments.push(this.mockComment(hash, message));
      this.conversationsService
        .comment_tracked_item(tracked_item_id, message)
        .then((res: any) => {
          message = "";
          this.isSendingComment = false;
          this.setCommentAsSent(hash, res);
          setTimeout(() => {
            input.focus();
          }, 100);
        })
        .catch((err) => {
          this.isSendingComment = false;
        })
        .finally(() => (message = ""));
    }
  }

  ngOnInit(): void {
    this.isAccountant = this.localStorage.get("data")["user_type"] === 1;
    this.user = this.localStorage.get("user");
    this.pusher = new Pusher(environment.pusherConfig.pusherAppKey, {
      cluster: environment.pusherConfig.pusherAppCluster,
    });
    this.dashboardStore._selectTrackedItem.subscribe((sub) => {
      if (sub.tracked_item != null) {
        this.tracked_item = sub.tracked_item;
        this.refreshTrackedItemComments();
        this.listenForTrackedItemComments();

        this.getTrackedItemAttachments();
        this.getTrackedItemFiles();

        this.cdr.detectChanges();

        setTimeout(() => {
          this.isOpen = true;
        });
        this.company = sub.company;

        // Get realmId accounts on QBO
        if (sub.tracked_item != null) {
          if (sub.tracked_item.company != null) {
            this.quickbooksIntegrationService
              .getAccountsByCompanyId(sub.tracked_item.company)
              .subscribe((res) => {
                this.accounts = res;
              });
            this.quickbooksIntegrationService
              .retrieveClasses(sub.tracked_item.company)
              .then(
                (res) => {
                  this.hasSelectableClass = res.enabled;
                  this.classes = res.classes;
                },
                (err) => {
                  if (err.status == 404) {
                    this.hasSelectableClass = false;
                  }
                },
              );
          }
        }

        if (this.channel != null) {
          this.channel.unbind();
          this.pusher.unsubscribe(this.channel.name);
          this.channel = null;
        } else {
          let conversationUuid = null;

          if (sub.company != null) {
            conversationUuid = sub.company.company_conversation;
          } else if (sub.tracked_item.conversation_uuid != null) {
            conversationUuid = sub.tracked_item.conversation_uuid;
          }

          if (conversationUuid != null) {
            this.channel = this.pusher.subscribe(
              `conversation-updates.${conversationUuid}`,
            );
            this.channel.bind("tracked-item-update", (message: any) => {
              if (message?.tracked_item?.uuid == this.tracked_item?.uuid) {
                this.tracked_item = message.tracked_item;
                this.cdr.detectChanges();
              }
            });
          }
        }

        if (this.tracked_item != null) {
          this.autoRemind = this.tracked_item.initial_reminder_date
            ? true
            : false;

          const reminderDate = new Date(sub.tracked_item.initial_reminder_date);
          const calculatedDays = Math.round(
            Math.floor(reminderDate.getTime() - new Date().getTime()) /
              (1000 * 60 * 60 * 24),
          );
          this.autoRemindDays =
            calculatedDays < 0 ? "0" : calculatedDays.toString();
        }
      } else {
        this.tracked_item = null;
      }
    });

    this.dashboardService.openDeleteTrackedItemModal.subscribe(
      (trackedItem) => {
        this.tracked_item = trackedItem;
        this.bsModalRef = this.modalService.show(
          this.deleteTrackedItemConfirmation,
          { class: "modal-md" },
        );
      },
    );
  }

  listenForTrackedItemComments() {
    if (!this.tracked_item) {
      this.realTimeService.unsetTrackedItemCommentsListener();
      return;
    }

    this.realTimeService.setTrackedItemCommentsListener(
      this.tracked_item?.uuid,
    );
    this.realTimeService.trackedItemComments.subscribe((message: any) => {
      if (message?.message) this.addComment(message);
      else this.refreshTrackedItemComments();
    });
  }

  refreshTrackedItemComments() {
    if (!this.tracked_item) return;

    this.conversationsService
      .getTrackedItemComments(this.tracked_item?.id)
      .subscribe(
        (res) => (this.tracked_item.comments = res),
        (err) => console.error(err.error.message),
      );
  }

  scrollToEnd() {
    this.commentsWrapper.nativeElement.scrollTop =
      this.commentsWrapper.nativeElement.scrollHeight;
  }

  canAutopilot(): boolean {
    if (this.tracked_item != null) {
      return ["draft", "open"].includes(this.tracked_item.answer_status);
    }
    return false;
  }

  saveAutoRemindSettings() {
    const initialRemindDate = new Date();
    this.tracked_item.initial_reminder_date = this.autoRemind
      ? initialRemindDate.setDate(
          initialRemindDate.getDate() + parseInt(this.autoRemindDays),
        )
      : null;
    this.conversationsService
      .setAutoRemind(
        this.tracked_item.uuid,
        this.autoRemind ? this.autoRemindDays : null,
      )
      .subscribe(
        (res) => this.handleSuccessSetAutoRemind(res),
        (err) => this.handleError(err),
      );
  }

  handleSuccessSetAutoRemind(res: any) {
    console.log(res.message);
  }
  handleError(err: any) {
    console.error(err.message);
  }

  mockComment(hash: string, text: string) {
    const message: any = {};
    message.uuid = hash;
    message.comment = null;
    message.date = null;
    message.edit_mode = false;
    message.edited = false;
    message.file = null;
    message.message = text;
    message.meta = {};
    message.pinned = false;
    message.reminder = null;
    message.reminder_creator = null;
    message.replyingTo = null;
    message.sent_by = this.user;
    message.system_message = false;
    message.tracked_item = this.tracked_item;

    return message;
  }

  addComment(comment: any) {
    const idx = this.tracked_item.comments.findIndex(
      (c: any) => c.uuid == comment.uuid,
    );
    if (idx > -1) this.tracked_item.comments[idx] = comment;
    else this.tracked_item.comments.push(comment);
  }

  setCommentAsSent(hash: string, comment: any) {
    const idx = this.tracked_item.comments.findIndex(
      (c: any) => c.uuid == hash,
    );
    this.tracked_item.comments[idx] = comment;
  }

  getTrackedItemAttachments() {
    if (!this.tracked_item) return;

    // Saving one API call a day keeps the doctor away
    if (this.tracked_item.attachments_qty > 0) {
      this.conversationsService
        .getTrackedItemAttachments(this.tracked_item?.uuid)
        .subscribe(
          (res) => {
            if (this.tracked_item != null) {
              this.tracked_item.attachments = res;
            }
          },
          (err) => console.error(err.error.message),
        );
    }
  }

  getTrackedItemFiles() {
    if (!this.tracked_item) return;

    // Saving one API call a day keeps the doctor away

    this.conversationsService
      .getTrackedItemFiles(this.tracked_item?.uuid)
      .subscribe(
        (res) => {
          if (this.tracked_item != null) {
            this.tracked_item.files = res;
          }
        },
        (err) => console.error(err.error.message),
      );
  }

  confirmClientTaskRemoval() {
    this.bsModalRef.hide();
    this.conversationsService
      .deleteTrackedItem(this.tracked_item?.uuid)
      .subscribe(
        (res) => {
          this.bsModalRef.hide();
          this.toastr.success("Client Task removed successfully");
          this.workspacesService.removeTrackedItem.next(this.tracked_item);
          this.tracked_item = null;
        },
        (err) => {
          this.toastr.warning(err.error.message);
          this.bsModalRef.hide();
        },
      );
  }
  getCommentCount() {
    return this.tracked_item?.comments?.length || 0;
  }

  openCompanyWorkspace() {
    if (this.tracked_item?.company) {
      const workspaceUrl = `${environment.frontUrl}practice/workspaces/${this.tracked_item?.company}/conversations`;
      window.open(workspaceUrl, '_blank');
    }
  }
}
